module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko_samples/sec03_pc_c1496bf72a549a4b9e52a806d3be925c.jpg";